<template>
  <div class="px-10">
    <v-expansion-panels
      v-model="panel"
      multiple
      class="elevation-2"
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="font-calibri font-16 font-weight-bold border-bottom-light-grey accordion-max-height">
          {{ section }} 
          <employee-profile-general-info-education-background-dialog-create
            v-if="panel.length > 0 && $hasPermissionTo(['create education backgrounds']) && !isMyProfile && !isResigned"
            :employee-uid="employeeUid"
            @created="loadEducationBackgrounds"
          />
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :headers="headers"
            :items="educationBackgrounds"
            hide-default-footer
            dense
            class="border mt-4"
          >
            <template v-slot:item.education_level.name="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                  class="loading-bar"
                />  
                <span v-else>
                  {{ item.education_level.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.education_major.name="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                  class="loading-bar"
                />  
                <span v-else>
                  {{ item.education_major.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.education_institution.name="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                  class="loading-bar"
                />  
                <span v-else>
                  {{ item.education_institution.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.country.name="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                  class="loading-bar"
                />  
                <span v-else>
                  {{ item.country.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.result="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                />  
                <span v-else>
                  {{ item.result?item.result:'N/A' }}
                </span>
              </div>
            </template>

            <template v-slot:item.graduation_year="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                />  
                <span v-else>
                  {{ item.graduation_year }}
                </span>
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <employee-profile-general-info-education-background-dialog-edit
                v-if="$hasPermissionTo(['update education backgrounds']) && !loading && !isMyProfile && !isResigned"
                :education-background="item"
                @updated="loadEducationBackgrounds"
              />
              <employee-profile-general-info-education-background-dialog-delete
                v-if="$hasPermissionTo(['delete education backgrounds']) && !loading && !isMyProfile && !isResigned"
                :education-background="item"
                @deleted="loadEducationBackgrounds"
              />
            </template> 
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeeProfileGeneralInfoEducationBackgroundDialogCreate: () => import('@/components/hris/employee/profile/general-info/education-background/DialogCreate'),
      EmployeeProfileGeneralInfoEducationBackgroundDialogEdit: () => import('@/components/hris/employee/profile/general-info/education-background/DialogEdit'),
      EmployeeProfileGeneralInfoEducationBackgroundDialogDelete: () => import('@/components/hris/employee/profile/general-info/education-background/DialogDelete'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        section: 'Education Backgrounds',
        educationBackgrounds: [],
        headers: [
          { 
            text: 'Education Level', 
            align: 'left',
            sortable: false,
            value: 'education_level.name',
          },
          {
            text: 'Major In',
            align: 'left',
            sortable: false,
            value: 'education_major.name',
          },
          { 
            text: 'Institute Name',
            align: 'left',
            sortable: false,
            value: 'education_institution.name',
          },
          { 
            text: 'Country',
            align: 'left',
            sortable: false,
            value: 'country.name', 
          },
          { 
            text: 'Result',
            align: 'center',
            sortable: false,
            value: 'result',
          },
          { 
            text: 'Graduation Year',
            align: 'center',
            sortable: false,
            value: 'graduation_year',
          },
          { 
            text: '',
            sortable: false,
            value: 'action', 
          },
        ],
        loading: false,
        panel: [0],
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadEducationBackgrounds()
          }
        },
      },
    },
  
    methods: {
      loadEducationBackgrounds () {
        this.loading = true

        this.$api.hrisEducationBackgrounds().list(this.employeeUid)
          .then(res => {
            this.educationBackgrounds = res.data

            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}

.border-bottom-light-grey{
  border-bottom:1px solid #e6e6e6;
}

.accordion-max-height{
  max-height: 36px !important;
}

.border{
  border:1px solid #e6e6e6;
}

.loading-bar >>> .v-skeleton-loader__list-item.v-skeleton-loader__bone{
  padding-left:0px
}
</style>
